<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.ratingtypes')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.ratingtype.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.ratingtype.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="ratingtypes"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="ratingtype-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="min_value">{{ t('common.labels.min_value') }}
                  <p-sortIcon field="min_value"></p-sortIcon>
              </th>
              <th pSortableColumn="max_value">{{ t('common.labels.max_value') }}
                  <p-sortIcon field="max_value"></p-sortIcon>
              </th>
              <th pSortableColumn="step">{{ t('common.labels.step') }}
                  <p-sortIcon field="step"></p-sortIcon>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ratingtype>
            <tr (click)="onOpen(ratingtype)" (keyup.enter)="onOpen(ratingtype)" hoverOnRight="admin.ratingtype.show" tabindex="0">
              <td><span role="link">{{ratingtype.getLang('name', transloco.getActiveLang())}}</span></td>
              <td>{{ratingtype.min_value}}</td>
              <td>{{ratingtype.max_value}}</td>
              <td>{{ratingtype.step}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
